import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { ContractService } from '@services/contract/contract.service';
import moment from 'moment-timezone';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingComponent } from '../../loading/loading.component';
import { RouterLink } from '@angular/router';

import { MixpanelService } from '@services/mixpanel/mixpanel.service';
import { SidebarService } from '@services/sidebar/sidebar.service';
import { AwTooltipComponent } from '@components/misc/aw-tooltip/aw-tooltip.component';
import { AW } from '@airwallet/types';

@Component({
    selector: 'app-contract-expiring-list',
    templateUrl: './contract-expiring-list.component.html',
    styleUrls: ['./contract-expiring-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, LoadingComponent, TranslateModule, AwTooltipComponent]
})
export class ContractExpiringListComponent implements OnInit {
    loading = signal(false);
    contracts = signal<(AW.Operator.Contract.ExpiringContract | '')[]>([]);

    constructor(
        private contractService: ContractService,
        private mixpanelService: MixpanelService,
        protected sidebarService: SidebarService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.getContracts();
    }

    async getContracts() {
        this.loading.set(true);
        const contracts: (AW.Operator.Contract.ExpiringContract | '')[] = await this.contractService.getExpiringContracts().then(response => {
            this.loading.set(false);
            return response as AW.Operator.Contract.ExpiringContract[];
        });

        for (let i = contracts.length; i < 11; i++) {
            contracts.push('');
        }
        this.contracts.set(contracts);
    }

    getPeriod(milsStamp: number) {
        return milsStamp ? moment.tz(moment(milsStamp, 'X'), 'UTC').tz(moment.tz.guess(false)).format('L').replace(/([.])/g, '/') : ' ';
    }

    isExpiring(timestamp: number): boolean {
        return moment().add(6, 'month').unix() > timestamp;
    }

    isSemiExpiring(timestamp: number): boolean {
        return moment().add(12, 'month').unix() > timestamp;
    }

    onLinkClick() {
        this.mixpanelService.track('Action: Go To List (Expiring Contract) Clicked', { action: 'go to contracts (expiring) list from home' });
    }
}
